window.GT_FITMENTS = [
  {
    "yearStart": 1991,
    "yearEnd": 2005,
    "brand": "Acura",
    "model": "NSX",
    "generation": "NA1 / NA2",
    "submodel": "Base",
    "front": "17x8 ET40",
    "rear": "17x9.5 ET40",
    "boltPattern": "5x114.3",
    "centerBore": "70.1",
    "guideUrl": "/pages/nsx-fitment",
    "setup": "17\" Staggered (NA1/NA2)"
  },
  {
    "yearStart": 1991,
    "yearEnd": 2005,
    "brand": "Acura",
    "model": "NSX",
    "generation": "NA1 / NA2",
    "submodel": "Base",
    "front": "20x9 ET40",
    "rear": "21x11.5 ET40",
    "boltPattern": "5x114.3",
    "centerBore": "70.1",
    "guideUrl": "/pages/nsx-fitment",
    "setup": "20/21\" Staggered (NC1)"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2022,
    "brand": "Acura",
    "model": "NSX",
    "generation": "NC1",
    "submodel": "Hybrid",
    "front": "17x8 ET40",
    "rear": "17x9.5 ET40",
    "boltPattern": "5x120",
    "centerBore": "64.1",
    "guideUrl": "/pages/nsx-fitment",
    "setup": "17\" Staggered (NA1/NA2)"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2022,
    "brand": "Acura",
    "model": "NSX",
    "generation": "NC1",
    "submodel": "Hybrid",
    "front": "20x9 ET40",
    "rear": "21x11.5 ET40",
    "boltPattern": "5x120",
    "centerBore": "64.1",
    "guideUrl": "/pages/nsx-fitment",
    "setup": "20/21\" Staggered (NC1)"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Alfa Romeo",
    "model": "Giulia",
    "generation": "952",
    "submodel": "Quadrifoglio",
    "front": "19x9 ET30",
    "rear": "19x10 ET32",
    "boltPattern": "5x110",
    "centerBore": "65.1",
    "guideUrl": "/pages/giulia-qv-fitment",
    "setup": "19\" Flush Stagger"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Alfa Romeo",
    "model": "Giulia",
    "generation": "952",
    "submodel": "Quadrifoglio",
    "front": "19x9.5 ET30",
    "rear": "19x10.5 ET35",
    "boltPattern": "5x110",
    "centerBore": "65.1",
    "guideUrl": "/pages/giulia-qv-fitment",
    "setup": "19\" Aggressive Track Stagger"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2026,
    "brand": "Aston Martin",
    "model": "Vantage",
    "generation": "Current Gen",
    "submodel": "AMR / F1",
    "front": "20x9.5 ET35",
    "rear": "20x11.5 ET32",
    "boltPattern": "5x128",
    "centerBore": "66.6",
    "guideUrl": "/pages/vantage-fitment",
    "setup": "20\" Flush Stagger (2019+)"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2026,
    "brand": "Aston Martin",
    "model": "Vantage",
    "generation": "Current Gen",
    "submodel": "AMR / F1",
    "front": "19x9 ET40",
    "rear": "19x10.5 ET45",
    "boltPattern": "5x128",
    "centerBore": "66.6",
    "guideUrl": "/pages/vantage-fitment",
    "setup": "19\" Flush Stagger (2006–2018)"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2018,
    "brand": "Aston Martin",
    "model": "Vantage",
    "generation": "Previous Gen",
    "submodel": "V8 / V12",
    "front": "20x9.5 ET35",
    "rear": "20x11.5 ET32",
    "boltPattern": "5x114.3",
    "centerBore": "68.1",
    "guideUrl": "/pages/vantage-fitment",
    "setup": "20\" Flush Stagger (2019+)"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2018,
    "brand": "Aston Martin",
    "model": "Vantage",
    "generation": "Previous Gen",
    "submodel": "V8 / V12",
    "front": "19x9 ET40",
    "rear": "19x10.5 ET45",
    "boltPattern": "5x114.3",
    "centerBore": "68.1",
    "guideUrl": "/pages/vantage-fitment",
    "setup": "19\" Flush Stagger (2006–2018)"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2023,
    "brand": "Audi",
    "model": "R8",
    "generation": "Gen 2",
    "submodel": "R8",
    "front": "20x9",
    "rear": "21x11.5 or 21x12",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/audi-r8-fitment",
    "setup": "20\" / 21\" Staggered (Street)"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2023,
    "brand": "Audi",
    "model": "R8",
    "generation": "Gen 2",
    "submodel": "R8",
    "front": "20x9",
    "rear": "20x11.5",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/audi-r8-fitment",
    "setup": "20\" Performance Setup"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2021,
    "brand": "Audi",
    "model": "RS 3",
    "generation": "8V",
    "submodel": "RS 3",
    "front": "9x18 ET42",
    "rear": "9x18 ET42",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Audi",
    "model": "RS 3",
    "generation": "8Y",
    "submodel": "RS 3",
    "front": "9.5x18 ET20",
    "rear": "9x18 ET42",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2020,
    "yearEnd": 2026,
    "brand": "Audi",
    "model": "RS 6",
    "generation": "C8",
    "submodel": "RS 6",
    "front": "10.5x21 ET8",
    "rear": "10.5x21 ET8",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Audi",
    "model": "RS3 / TTRS",
    "generation": "8V / 8Y / 8S",
    "submodel": "5-Cylinder Turbo",
    "front": "19x9 ET30",
    "rear": "19x9 ET30",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/rs3-fitment",
    "setup": "19\" Flush Square"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Audi",
    "model": "RS3 / TTRS",
    "generation": "8V / 8Y / 8S",
    "submodel": "5-Cylinder Turbo",
    "front": "18x9 ET35",
    "rear": "18x9 ET35",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/rs3-fitment",
    "setup": "18\" Lightweight Track Square"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2026,
    "brand": "Audi",
    "model": "S4 / S5",
    "generation": "B8 / B9",
    "submodel": "Premium / Prestige",
    "front": "19x9.5 ET35",
    "rear": "19x9.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/audi-b8-fitment",
    "setup": "19\" Flush Square"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2026,
    "brand": "Audi",
    "model": "S4 / S5",
    "generation": "B8 / B9",
    "submodel": "Premium / Prestige",
    "front": "18x9 ET38",
    "rear": "18x9 ET38",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/audi-b8-fitment",
    "setup": "18\" Lightweight Track Square"
  },
  {
    "yearStart": 2011,
    "yearEnd": 2012,
    "brand": "BMW",
    "model": "1M",
    "generation": "E82",
    "submodel": "Coupe",
    "front": "19x9 ET25",
    "rear": "19x10 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/1m-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2011,
    "yearEnd": 2012,
    "brand": "BMW",
    "model": "1M",
    "generation": "E82",
    "submodel": "Coupe",
    "front": "18x9.5 ET22",
    "rear": "18x9.5 ET22",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/1m-fitment",
    "setup": "18\" Track Square"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2021,
    "brand": "BMW",
    "model": "2 Series",
    "generation": "F22 F23",
    "submodel": "228i / 230i / M235i / M240i",
    "front": "18x8.5 ET35",
    "rear": "18x9.5 ET45 (ET50 if using extremely wide 255+ tires)",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f22-fitment",
    "setup": "18\" Staggered Setup"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2021,
    "brand": "BMW",
    "model": "2 Series",
    "generation": "F22 F23",
    "submodel": "228i / 230i / M235i / M240i",
    "front": "18x8.5 ET35",
    "rear": "18x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f22-fitment",
    "setup": "18\" Square Track Setup"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "2 Series",
    "generation": "G42",
    "submodel": "230i / M240i",
    "front": "19x8.5 ET25",
    "rear": "19x9.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g42-fitment",
    "setup": "19\" Staggered Street Setup"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "2 Series",
    "generation": "G42",
    "submodel": "230i / M240i",
    "front": "19x9 ET25",
    "rear": "19x9 ET25",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g42-fitment",
    "setup": "19\" Square Track Setup"
  },
  {
    "yearStart": 1982,
    "yearEnd": 1991,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E30",
    "submodel": "318i / 325i / 325e / 325is",
    "front": "17x8 ET25",
    "rear": "17x9 ET25",
    "boltPattern": "4x100",
    "centerBore": "57.1",
    "guideUrl": "/pages/e30-fitment",
    "setup": "17\" Staggered Daily Setup"
  },
  {
    "yearStart": 1982,
    "yearEnd": 1991,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E30",
    "submodel": "318i / 325i / 325e / 325is",
    "front": "17x8 ET25",
    "rear": "17x8 ET25",
    "boltPattern": "4x100",
    "centerBore": "57.1",
    "guideUrl": "/pages/e30-fitment",
    "setup": "17\" Square Setup"
  },
  {
    "yearStart": 1992,
    "yearEnd": 1999,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E36",
    "submodel": "318i / 323i / 325i / 328i",
    "front": "18x8.5 ET35",
    "rear": "18x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e36-fitment",
    "setup": "18\" Staggered Daily Setup"
  },
  {
    "yearStart": 1992,
    "yearEnd": 1999,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E36",
    "submodel": "318i / 323i / 325i / 328i",
    "front": "18x8.5 ET35",
    "rear": "18x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e36-fitment",
    "setup": "18\" Square Setup"
  },
  {
    "yearStart": 1999,
    "yearEnd": 2006,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E46",
    "submodel": "323i / 325i / 328i / 330i",
    "front": "18x8.5 ET35",
    "rear": "18x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e46-fitment",
    "setup": "18\" Staggered Daily Setup"
  },
  {
    "yearStart": 1999,
    "yearEnd": 2006,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E46",
    "submodel": "323i / 325i / 328i / 330i",
    "front": "18x8.5 ET35",
    "rear": "18x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e46-fitment",
    "setup": "18\" Square Setup"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2012,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E90 E91 LCI",
    "submodel": "328i / 335i",
    "front": "19x8.5 ET35",
    "rear": "19x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e90-lci-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2012,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E90 E91 LCI",
    "submodel": "328i / 335i",
    "front": "19x8.5 ET35",
    "rear": "19x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e90-lci-fitment",
    "setup": "19\" Square Setup"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2013,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E90 E91 Pre-LCI / E92 E93",
    "submodel": "325i / 328i / 330i / 335i",
    "front": "19x8.5 ET35",
    "rear": "19x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e90-lci-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2013,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "E90 E91 Pre-LCI / E92 E93",
    "submodel": "325i / 328i / 330i / 335i",
    "front": "19x8.5 ET35",
    "rear": "19x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e90-lci-fitment",
    "setup": "19\" Square Setup"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2018,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "F30 F31 F34",
    "submodel": "328i / 335i / 340i",
    "front": "19x8.5 ET35",
    "rear": "19x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f30-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2018,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "F30 F31 F34",
    "submodel": "328i / 335i / 340i",
    "front": "20x8.5 ET35",
    "rear": "20x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f30-fitment",
    "setup": "20\" Staggered Maximum Aesthetics"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2018,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "F30 F31 F34",
    "submodel": "328i / 335i / 340i",
    "front": "19x8.5 ET35",
    "rear": "19x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f30-fitment",
    "setup": "19\" Square Setup"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "G20 G21",
    "submodel": "330i / M340i",
    "front": "19x8.5 ET25",
    "rear": "19x9.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g20-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "G20 G21",
    "submodel": "330i / M340i",
    "front": "20x8.5 ET25",
    "rear": "20x9.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g20-fitment",
    "setup": "20\" Staggered Maximum Aesthetics"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "3 Series",
    "generation": "G20 G21",
    "submodel": "330i / M340i",
    "front": "19x9 ET25",
    "rear": "19x9 ET25",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g20-fitment",
    "setup": "19\" Square Setup"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2020,
    "brand": "BMW",
    "model": "4 Series",
    "generation": "F32 F33 F36",
    "submodel": "428i / 435i / 440i",
    "front": "19x8.5 ET35",
    "rear": "19x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f32-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2020,
    "brand": "BMW",
    "model": "4 Series",
    "generation": "F32 F33 F36",
    "submodel": "428i / 435i / 440i",
    "front": "20x8.5 ET35",
    "rear": "20x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f32-fitment",
    "setup": "20\" Staggered Maximum Aesthetics"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2020,
    "brand": "BMW",
    "model": "4 Series",
    "generation": "F32 F33 F36",
    "submodel": "428i / 435i / 440i",
    "front": "19x8.5 ET35",
    "rear": "19x8.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f32-fitment",
    "setup": "19\" Square Setup"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "4 Series",
    "generation": "G22 G23 G26",
    "submodel": "430i / M440i",
    "front": "19x8.5 ET25",
    "rear": "19x9.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g22-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "4 Series",
    "generation": "G22 G23 G26",
    "submodel": "430i / M440i",
    "front": "20x8.5 ET25",
    "rear": "20x9.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g22-fitment",
    "setup": "20\" Staggered Maximum Aesthetics"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "4 Series",
    "generation": "G22 G23 G26",
    "submodel": "430i / M440i",
    "front": "19x9 ET25",
    "rear": "19x9 ET25",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g22-fitment",
    "setup": "19\" Square Setup"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2022,
    "brand": "BMW",
    "model": "M2",
    "generation": "F87",
    "submodel": "M2 / Competition",
    "front": "19x9.5 ET28",
    "rear": "19x10.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f87-m2-fitment",
    "setup": "19\" Staggered Daily Setup"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2022,
    "brand": "BMW",
    "model": "M2",
    "generation": "F87",
    "submodel": "M2 / Competition",
    "front": "19x10 ET25",
    "rear": "19x10 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f87-m2-fitment",
    "setup": "19\" Square Track Setup"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "M2",
    "generation": "G87",
    "submodel": "M2 / Competition",
    "front": "19x10 ET12",
    "rear": "20x11 ET14",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/m2-fitment",
    "setup": "Staggered Street & Track"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "M2",
    "generation": "G87",
    "submodel": "M2 / Competition",
    "front": "19x10.5 ET14",
    "rear": "19x10.5 ET14",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/m2-fitment",
    "setup": "19\" Square Track Focus"
  },
  {
    "yearStart": 1986,
    "yearEnd": 1991,
    "brand": "BMW",
    "model": "M3",
    "generation": "E30",
    "submodel": "Base / Evo",
    "front": "17x8.5 ET20",
    "rear": "17x9.5 ET20",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e30-m3-fitment",
    "setup": "17\" Staggered Street Setup"
  },
  {
    "yearStart": 1986,
    "yearEnd": 1991,
    "brand": "BMW",
    "model": "M3",
    "generation": "E30",
    "submodel": "Base / Evo",
    "front": "17x8.5 ET20",
    "rear": "17x8.5 ET20",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e30-m3-fitment",
    "setup": "17\" Square Track Setup"
  },
  {
    "yearStart": 1992,
    "yearEnd": 1999,
    "brand": "BMW",
    "model": "M3",
    "generation": "E36",
    "submodel": "Base",
    "front": "18x8.5 ET35",
    "rear": "18x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e36-m3-fitment",
    "setup": "18\" Staggered Street Setup"
  },
  {
    "yearStart": 1992,
    "yearEnd": 1999,
    "brand": "BMW",
    "model": "M3",
    "generation": "E36",
    "submodel": "Base",
    "front": "17x8.5 ET40",
    "rear": "17x8.5 ET40",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e36-m3-fitment",
    "setup": "17\" Square Track Setup"
  },
  {
    "yearStart": 2001,
    "yearEnd": 2006,
    "brand": "BMW",
    "model": "M3",
    "generation": "E46",
    "submodel": "Base / Competition",
    "front": "19x9 ET30",
    "rear": "19x10 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e46-m3-fitment",
    "setup": "19\" Staggered Maximum Aesthetics"
  },
  {
    "yearStart": 2001,
    "yearEnd": 2006,
    "brand": "BMW",
    "model": "M3",
    "generation": "E46",
    "submodel": "Base / Competition",
    "front": "18x9.5 ET35",
    "rear": "18x9.5 ET35",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e46-m3-fitment",
    "setup": "18\" Square Track Setup"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2013,
    "brand": "BMW",
    "model": "M3",
    "generation": "E90 E92 E93",
    "submodel": "M3",
    "front": "19x9.5 ET22",
    "rear": "19x10.5 ET22",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e9x-m3-fitment",
    "setup": "19\" Staggered Maximum Aesthetics"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2013,
    "brand": "BMW",
    "model": "M3",
    "generation": "E90 E92 E93",
    "submodel": "M3",
    "front": "18x10 ET25",
    "rear": "18x10 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e9x-m3-fitment",
    "setup": "18\" Square Track Setup"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M3",
    "generation": "F80",
    "submodel": "M3 / Competition",
    "front": "19x9.5",
    "rear": "19x10.5 or 19x11",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f80-m3-fitment",
    "setup": "19\" Track & Street Standard"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M3",
    "generation": "F80",
    "submodel": "M3 / Competition",
    "front": "20x9.5",
    "rear": "20x11",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/f80-m3-fitment",
    "setup": "20\" Staggered Fitment"
  },
  {
    "yearStart": 2021,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "M3",
    "generation": "G80",
    "submodel": "M3 / Competition",
    "front": "19x10 ET12",
    "rear": "20x11 ET14",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g80-m3-fitment",
    "setup": "Staggered Street & Track"
  },
  {
    "yearStart": 2021,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "M3",
    "generation": "G80",
    "submodel": "M3 / Competition",
    "front": "19x10.5 ET14",
    "rear": "19x10.5 ET14",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/g80-m3-fitment",
    "setup": "19\" Square Track Focus"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "",
    "rear": "10.5x19 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "",
    "rear": "10.5x19 ET45",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "",
    "rear": "11x20 ET44",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "",
    "rear": "9.5x20 ET22",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "10x19 ET25",
    "rear": "9.5x19 ET22",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "10x19 ET40",
    "rear": "10x19 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "9.5x19 ET22",
    "rear": "11x19 ET44",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "9.5x20 ET22",
    "rear": "10x19 ET40",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "BMW",
    "model": "M4",
    "generation": "F82",
    "submodel": "M4 / Competition",
    "front": "9x19 ET30",
    "rear": "9x19 ET30",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2021,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "M4",
    "generation": "G82 G83",
    "submodel": "M4 / Competition",
    "front": "19x10 ET12",
    "rear": "20x11 ET14",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Staggered Street & Track"
  },
  {
    "yearStart": 2021,
    "yearEnd": 2026,
    "brand": "BMW",
    "model": "M4",
    "generation": "G82 G83",
    "submodel": "M4 / Competition",
    "front": "19x10.5 ET14",
    "rear": "19x10.5 ET14",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "19\" Square Track Focus"
  },
  {
    "yearStart": 2005,
    "yearEnd": 2010,
    "brand": "BMW",
    "model": "M5",
    "generation": "E60",
    "submodel": "V10",
    "front": "19x9.5 ET22",
    "rear": "19x10 ET25",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e60-m5-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2005,
    "yearEnd": 2010,
    "brand": "BMW",
    "model": "M5",
    "generation": "E60",
    "submodel": "V10",
    "front": "20x9 ET25",
    "rear": "20x10.5 ET22",
    "boltPattern": "5x120",
    "centerBore": "72.56",
    "guideUrl": "/pages/e60-m5-fitment",
    "setup": "20\" Grand Touring Stagger"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2024,
    "brand": "BMW",
    "model": "M5",
    "generation": "F90",
    "submodel": "Base / Competition",
    "front": "21x10 ET25",
    "rear": "21x11 ET28",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/m5-fitment",
    "setup": "21\" Aggressive Stagger"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2024,
    "brand": "BMW",
    "model": "M5",
    "generation": "F90",
    "submodel": "Base / Competition",
    "front": "20x10 ET28",
    "rear": "20x11 ET30",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/m5-fitment",
    "setup": "20\" Staggered Track"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Cadillac",
    "model": "CT4-V / CT5-V",
    "generation": "Blackwing",
    "submodel": "Blackwing",
    "front": "19x9.5 ET30",
    "rear": "19x10.5 ET25",
    "boltPattern": "5x120",
    "centerBore": "67",
    "guideUrl": "/pages/blackwing-fitment",
    "setup": "19\" Flush Stagger"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Cadillac",
    "model": "CT4-V / CT5-V",
    "generation": "Blackwing",
    "submodel": "Blackwing",
    "front": "18x10 ET30",
    "rear": "18x10 ET30",
    "boltPattern": "5x120",
    "centerBore": "67",
    "guideUrl": "/pages/blackwing-fitment",
    "setup": "18\" Square Track"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2024,
    "brand": "Chevrolet",
    "model": "Camaro",
    "generation": "6th Gen",
    "submodel": "SS 1LE / ZL1",
    "front": "20x10 ET30",
    "rear": "20x11 ET35",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/camaro-fitment",
    "setup": "20\" Staggered Street"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2024,
    "brand": "Chevrolet",
    "model": "Camaro",
    "generation": "6th Gen",
    "submodel": "SS 1LE / ZL1",
    "front": "18x10 ET30",
    "rear": "18x10 ET30",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/camaro-fitment",
    "setup": "18\" Square Track"
  },
  {
    "yearStart": 2005,
    "yearEnd": 2013,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C6",
    "submodel": "Base / Z51",
    "front": "18x8.5 ET55",
    "rear": "19x10 ET58",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c6-base-fitment",
    "setup": "18/19\" Flush Stagger"
  },
  {
    "yearStart": 2005,
    "yearEnd": 2013,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C6",
    "submodel": "Base / Z51",
    "front": "19x8.5 ET50",
    "rear": "20x10 ET55",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c6-base-fitment",
    "setup": "19/20\" Mild Poke Stagger"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2013,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C6",
    "submodel": "Grand Sport / Z06 / ZR1",
    "front": "19x10 ET40",
    "rear": "20x12 ET45",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c6-z06-fitment",
    "setup": "19/20\" Flush Stagger"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2013,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C6",
    "submodel": "Grand Sport / Z06 / ZR1",
    "front": "18x10.5 ET40",
    "rear": "18x10.5 ET40",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c6-z06-fitment",
    "setup": "18\" Square Track Setup"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2019,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C7",
    "submodel": "Grand Sport / Z06 / ZR1",
    "front": "19x10 ET32",
    "rear": "20x12 ET41",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c7-z06-fitment",
    "setup": "19/20\" Flush Stagger"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2019,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C7",
    "submodel": "Grand Sport / Z06 / ZR1",
    "front": "19x11 ET35",
    "rear": "19x11 ET35",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c7-z06-fitment",
    "setup": "19\" Square Track Setup"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C7",
    "submodel": "Stingray / Z51",
    "front": "19x8.5 ET56",
    "rear": "20x10 ET60",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c7-stingray-fitment",
    "setup": "19/20\" OEM+ Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C7",
    "submodel": "Stingray / Z51",
    "front": "18x8.5 ET56",
    "rear": "19x10 ET58",
    "boltPattern": "5x120.65",
    "centerBore": "70.3",
    "guideUrl": "/pages/c7-stingray-fitment",
    "setup": "18/19\" Comfort Stagger"
  },
  {
    "yearStart": 2020,
    "yearEnd": 2026,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C8",
    "submodel": "Stingray / Z51",
    "front": "19x8.5 ET52",
    "rear": "20x11 ET65",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/c8-stingray-fitment",
    "setup": "19/20\" Factory Stagger"
  },
  {
    "yearStart": 2020,
    "yearEnd": 2026,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C8",
    "submodel": "Stingray / Z51",
    "front": "19x9 ET45",
    "rear": "20x11 ET55",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/c8-stingray-fitment",
    "setup": "19/20\" Mild Poke Stagger"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C8",
    "submodel": "Z06 / E-Ray / Grand Sport",
    "front": "20x10 ET30",
    "rear": "21x13 ET38",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/c8-z06-fitment",
    "setup": "20/21\" Widebody Stagger"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C8",
    "submodel": "Z06 / E-Ray / Grand Sport",
    "front": "19x10 ET35",
    "rear": "20x12 ET35",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/c8-z06-fitment",
    "setup": "19/20\" Track Stagger"
  },
  {
    "yearStart": 2025,
    "yearEnd": 2026,
    "brand": "Chevrolet",
    "model": "Corvette",
    "generation": "C8",
    "submodel": "ZR1",
    "front": "20x10 ET30",
    "rear": "21x13 ET40",
    "boltPattern": "5x120",
    "centerBore": "66.9",
    "guideUrl": "/pages/c8-zr1-fitment",
    "setup": "20/21\" Factory Stagger"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2024,
    "brand": "Dodge",
    "model": "Charger / Challenger",
    "generation": "Widebody",
    "submodel": "Scat Pack / Hellcat",
    "front": "20x11 ET-2",
    "rear": "20x11 ET-2",
    "boltPattern": "5x115",
    "centerBore": "71.5",
    "guideUrl": "/pages/dodge-wb-fitment",
    "setup": "20\" Flush Square"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2024,
    "brand": "Dodge",
    "model": "Charger / Challenger",
    "generation": "Widebody",
    "submodel": "Scat Pack / Hellcat",
    "front": "20x9.5 ET15",
    "rear": "20x11 ET-2",
    "boltPattern": "5x115",
    "centerBore": "71.5",
    "guideUrl": "/pages/dodge-wb-fitment",
    "setup": "20\" Drag Stagger"
  },
  {
    "yearStart": 2003,
    "yearEnd": 2017,
    "brand": "Dodge",
    "model": "Viper",
    "generation": "Gen 3 / Gen 4 / Gen 5",
    "submodel": "SRT / GTS / ACR",
    "front": "19x10 ET28",
    "rear": "19x13 ET15",
    "boltPattern": "5x115.5",
    "centerBore": "71.5",
    "guideUrl": "/pages/viper-fitment",
    "setup": "19\" Exotic Stagger"
  },
  {
    "yearStart": 2003,
    "yearEnd": 2017,
    "brand": "Dodge",
    "model": "Viper",
    "generation": "Gen 3 / Gen 4 / Gen 5",
    "submodel": "SRT / GTS / ACR",
    "front": "18x11 ET25",
    "rear": "19x13 ET15",
    "boltPattern": "5x115.5",
    "centerBore": "71.5",
    "guideUrl": "/pages/viper-fitment",
    "setup": "18/19\" Track Stagger"
  },
  {
    "yearStart": 2010,
    "yearEnd": 2026,
    "brand": "Ferrari",
    "model": "V8 Berlinetta",
    "generation": "Various",
    "submodel": "458 / 488 / F8 / 296",
    "front": "20x9 ET35",
    "rear": "21x12 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/ferrari-fitment",
    "setup": "20/21\" Factory Stagger"
  },
  {
    "yearStart": 2010,
    "yearEnd": 2026,
    "brand": "Ferrari",
    "model": "V8 Berlinetta",
    "generation": "Various",
    "submodel": "458 / 488 / F8 / 296",
    "front": "19x9 ET40",
    "rear": "20x12 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/ferrari-fitment",
    "setup": "19/20\" Track Stagger"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2026,
    "brand": "Ford",
    "model": "Mustang",
    "generation": "S550 / S650",
    "submodel": "GT / Mach 1 / Dark Horse",
    "front": "19x10 ET35",
    "rear": "19x11 ET25",
    "boltPattern": "5x114.3",
    "centerBore": "70.5",
    "guideUrl": "/pages/mustang-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2026,
    "brand": "Ford",
    "model": "Mustang",
    "generation": "S550 / S650",
    "submodel": "GT / Mach 1 / Dark Horse",
    "front": "18x10 ET35",
    "rear": "18x10 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "70.5",
    "guideUrl": "/pages/mustang-fitment",
    "setup": "18\" Square Track Setup"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2026,
    "brand": "Genesis",
    "model": "G70",
    "generation": "IK",
    "submodel": "3.3T / 2.0T",
    "front": "19x8.5 ET35",
    "rear": "19x9.5 ET38",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/genesis-g70-fitment",
    "setup": "19\" Flush Stagger (RWD)"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2026,
    "brand": "Genesis",
    "model": "G70",
    "generation": "IK",
    "submodel": "3.3T / 2.0T",
    "front": "19x8.5 ET35",
    "rear": "19x8.5 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/genesis-g70-fitment",
    "setup": "19\" Square (AWD)"
  },
  {
    "yearStart": 2000,
    "yearEnd": 2009,
    "brand": "Honda",
    "model": "S2000",
    "generation": "AP1 / AP2",
    "submodel": "Base / CR",
    "front": "17x8 ET45",
    "rear": "17x9 ET45",
    "boltPattern": "5x114.3",
    "centerBore": "70.1",
    "guideUrl": "/pages/s2000-fitment",
    "setup": "17\" OEM+ Stagger"
  },
  {
    "yearStart": 2000,
    "yearEnd": 2009,
    "brand": "Honda",
    "model": "S2000",
    "generation": "AP1 / AP2",
    "submodel": "Base / CR",
    "front": "16x8 ET35",
    "rear": "16x8 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "70.1",
    "guideUrl": "/pages/s2000-fitment",
    "setup": "16\" Lightweight Square"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Honda / Acura",
    "model": "Civic Type R / Integra Type S",
    "generation": "FK8 / FL5 / DE5",
    "submodel": "Type R / Type S",
    "front": "19x9.5 ET45",
    "rear": "19x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "64.1",
    "guideUrl": "/pages/ctr-fitment",
    "setup": "19\" Flush Square"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Honda / Acura",
    "model": "Civic Type R / Integra Type S",
    "generation": "FK8 / FL5 / DE5",
    "submodel": "Type R / Type S",
    "front": "18x9.5 ET45",
    "rear": "18x9.5 ET45",
    "boltPattern": "5x120",
    "centerBore": "64.1",
    "guideUrl": "/pages/ctr-fitment",
    "setup": "18\" Lightweight Track Square"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2026,
    "brand": "Hyundai",
    "model": "Elantra N / Veloster N",
    "generation": "CN7 / JS",
    "submodel": "N / N Line",
    "front": "19x9 ET45",
    "rear": "19x9 ET45",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/hyundai-n-fitment",
    "setup": "19\" Flush Square"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2026,
    "brand": "Hyundai",
    "model": "Elantra N / Veloster N",
    "generation": "CN7 / JS",
    "submodel": "N / N Line",
    "front": "18x9 ET42",
    "rear": "18x9 ET42",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/hyundai-n-fitment",
    "setup": "18\" Lightweight Track Square"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2026,
    "brand": "Infiniti",
    "model": "G37 / Q50 / Q60",
    "generation": "V36 / V37",
    "submodel": "Base / Red Sport",
    "front": "19x9.5 ET30",
    "rear": "19x10.5 ET25",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/infiniti-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2026,
    "brand": "Infiniti",
    "model": "G37 / Q50 / Q60",
    "generation": "V36 / V37",
    "submodel": "Base / Red Sport",
    "front": "18x9.5 ET28",
    "rear": "18x9.5 ET28",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/infiniti-fitment",
    "setup": "18\" Square Track"
  },
  {
    "yearStart": 2011,
    "yearEnd": 2022,
    "brand": "Lamborghini",
    "model": "Aventador",
    "generation": "LP",
    "submodel": "LP700-4 / S",
    "front": "20x9 ET30",
    "rear": "21x13 ET30",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/aventador-fitment",
    "setup": "20/21\" Hypercar Stagger"
  },
  {
    "yearStart": 2011,
    "yearEnd": 2022,
    "brand": "Lamborghini",
    "model": "Aventador",
    "generation": "LP",
    "submodel": "LP700-4 / S",
    "front": "20x9 ET32",
    "rear": "20x12.5 ET32",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/aventador-fitment",
    "setup": "20\" Simplified Track Stagger"
  },
  {
    "yearStart": 2003,
    "yearEnd": 2014,
    "brand": "Lamborghini",
    "model": "Gallardo",
    "generation": "Gen 1 / Gen 2",
    "submodel": "Base / Superleggera",
    "front": "20x9 ET35",
    "rear": "20x11 ET35",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/gallardo-fitment",
    "setup": "20\" Flush Stagger"
  },
  {
    "yearStart": 2003,
    "yearEnd": 2014,
    "brand": "Lamborghini",
    "model": "Gallardo",
    "generation": "Gen 1 / Gen 2",
    "submodel": "Base / Superleggera",
    "front": "19x8.5 ET42",
    "rear": "19x11 ET35",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/gallardo-fitment",
    "setup": "19\" Comfortable Stagger"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2024,
    "brand": "Lamborghini",
    "model": "Huracan",
    "generation": "LP / EVO",
    "submodel": "Base / LP610-4 / EVO / Tecnica",
    "front": "20x9 ET35",
    "rear": "21x11.5 ET40",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/huracan-base-fitment",
    "setup": "20/21\" Factory Stagger"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2024,
    "brand": "Lamborghini",
    "model": "Huracan",
    "generation": "LP / EVO",
    "submodel": "Base / LP610-4 / EVO / Tecnica",
    "front": "19x9 ET40",
    "rear": "20x12 ET40",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/huracan-base-fitment",
    "setup": "19/20\" Track Stagger"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2024,
    "brand": "Lamborghini",
    "model": "Huracan",
    "generation": "Performante / STO",
    "submodel": "Performante / STO",
    "front": "20x9 ET30",
    "rear": "20x12 ET35",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/huracan-perf-fitment",
    "setup": "20\" Flush Track Stagger"
  },
  {
    "yearStart": 2018,
    "yearEnd": 2024,
    "brand": "Lamborghini",
    "model": "Huracan",
    "generation": "Performante / STO",
    "submodel": "Performante / STO",
    "front": "20x9 ET35",
    "rear": "21x12.5 ET40",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/huracan-perf-fitment",
    "setup": "20/21\" Show Stagger"
  },
  {
    "yearStart": 2024,
    "yearEnd": 2026,
    "brand": "Lamborghini",
    "model": "Revuelto",
    "generation": "V12 Hybrid",
    "submodel": "Base",
    "front": "21x9.5 ET30",
    "rear": "22x12.5 ET30",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/revuelto-fitment",
    "setup": "21/22\" Factory Stagger"
  },
  {
    "yearStart": 2025,
    "yearEnd": 2026,
    "brand": "Lamborghini",
    "model": "Temerario",
    "generation": "V8 Hybrid",
    "submodel": "Base",
    "front": "20x9 ET35",
    "rear": "21x11.5 ET40",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/temerario-fitment",
    "setup": "20/21\" Factory Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2026,
    "brand": "Lexus",
    "model": "IS / RC / GS",
    "generation": "Various",
    "submodel": "F-Sport",
    "front": "19x9 ET35",
    "rear": "19x10 ET40",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/lexus-fitment",
    "setup": "19\" Flush Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2026,
    "brand": "Lexus",
    "model": "IS / RC / GS",
    "generation": "Various",
    "submodel": "F-Sport",
    "front": "18x9 ET38",
    "rear": "18x9 ET38",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/lexus-fitment",
    "setup": "18\" Square Track"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Lotus",
    "model": "Emira",
    "generation": "Type 131",
    "submodel": "V6 / i4",
    "front": "20x8.5 ET50",
    "rear": "20x10.5 ET45",
    "boltPattern": "5x114.3",
    "centerBore": "68",
    "guideUrl": "/pages/emira-fitment",
    "setup": "20\" Flush Stagger"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Lotus",
    "model": "Emira",
    "generation": "Type 131",
    "submodel": "V6 / i4",
    "front": "18x8 ET45",
    "rear": "18x10 ET40",
    "boltPattern": "5x114.3",
    "centerBore": "68",
    "guideUrl": "/pages/emira-fitment",
    "setup": "18\" Track Stagger"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2026,
    "brand": "Mazda",
    "model": "MX-5 Miata",
    "generation": "ND",
    "submodel": "MX-5 Miata",
    "front": "17x9 +45 (requires negative camber and fender roll depending on tire).",
    "rear": "17x9 +45 (requires negative camber and fender roll depending on tire).",
    "boltPattern": "4x100",
    "centerBore": "54.1",
    "guideUrl": "/pages/miata-fitment",
    "setup": "The Track Standard: 17x9"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2026,
    "brand": "Mazda",
    "model": "MX-5 Miata",
    "generation": "ND",
    "submodel": "MX-5 Miata",
    "front": "17x8 +35 or +40. Pushes the wheel out flush with the fender without requiring body modification.",
    "rear": "17x8 +35 or +40. Pushes the wheel out flush with the fender without requiring body modification.",
    "boltPattern": "4x100",
    "centerBore": "54.1",
    "guideUrl": "/pages/miata-fitment",
    "setup": "17x8 Street Performance"
  },
  {
    "yearStart": 1990,
    "yearEnd": 2005,
    "brand": "Mazda",
    "model": "Miata",
    "generation": "NA / NB",
    "submodel": "Base",
    "front": "15x8 ET25",
    "rear": "15x8 ET25",
    "boltPattern": "4x100",
    "centerBore": "54.1",
    "guideUrl": "/pages/miata-na-fitment",
    "setup": "15\" Flush Square"
  },
  {
    "yearStart": 1990,
    "yearEnd": 2005,
    "brand": "Mazda",
    "model": "Miata",
    "generation": "NA / NB",
    "submodel": "Base",
    "front": "15x9 ET36",
    "rear": "15x9 ET36",
    "boltPattern": "4x100",
    "centerBore": "54.1",
    "guideUrl": "/pages/miata-na-fitment",
    "setup": "15x9 Wide Square"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2015,
    "brand": "Mazda",
    "model": "Miata",
    "generation": "NC",
    "submodel": "Base / Club",
    "front": "17x9 ET45",
    "rear": "17x9 ET45",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/miata-nc-fitment",
    "setup": "17\" Flush Square"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2015,
    "brand": "Mazda",
    "model": "Miata",
    "generation": "NC",
    "submodel": "Base / Club",
    "front": "16x8 ET35",
    "rear": "16x8 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/miata-nc-fitment",
    "setup": "16\" Lightweight Track Square"
  },
  {
    "yearStart": 1993,
    "yearEnd": 2002,
    "brand": "Mazda",
    "model": "RX-7",
    "generation": "FD3S",
    "submodel": "Base",
    "front": "18x9 ET35",
    "rear": "18x10 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/rx7-fitment",
    "setup": "18\" Safe Stagger"
  },
  {
    "yearStart": 1993,
    "yearEnd": 2002,
    "brand": "Mazda",
    "model": "RX-7",
    "generation": "FD3S",
    "submodel": "Base",
    "front": "17x9 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/rx7-fitment",
    "setup": "17\" Lightweight Square"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2026,
    "brand": "McLaren",
    "model": "Super Series",
    "generation": "Various",
    "submodel": "720S / 765LT / 600LT / Artura",
    "front": "20x9 ET35",
    "rear": "21x12 ET35",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/mclaren-fitment",
    "setup": "20/21\" Super Series Stagger"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2026,
    "brand": "McLaren",
    "model": "Super Series",
    "generation": "Various",
    "submodel": "720S / 765LT / 600LT / Artura",
    "front": "19x9 ET40",
    "rear": "20x11 ET35",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/mclaren-fitment",
    "setup": "19/20\" Sport/Track Stagger"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2015,
    "brand": "Mercedes-AMG",
    "model": "C63",
    "generation": "W204",
    "submodel": "Base / Black Series",
    "front": "19x9.5 ET28",
    "rear": "19x10.5 ET30",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/c63-fitment",
    "setup": "19\" Aggressive Stagger (W205)"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2015,
    "brand": "Mercedes-AMG",
    "model": "C63",
    "generation": "W204",
    "submodel": "Base / Black Series",
    "front": "19x9 ET25",
    "rear": "19x10 ET30",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/c63-fitment",
    "setup": "19\" Flush Stagger (W204)"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2022,
    "brand": "Mercedes-AMG",
    "model": "C63",
    "generation": "W205",
    "submodel": "Base / S",
    "front": "19x9.5 ET28",
    "rear": "19x10.5 ET30",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/c63-fitment",
    "setup": "19\" Aggressive Stagger (W205)"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2022,
    "brand": "Mercedes-AMG",
    "model": "C63",
    "generation": "W205",
    "submodel": "Base / S",
    "front": "19x9 ET25",
    "rear": "19x10 ET30",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/c63-fitment",
    "setup": "19\" Flush Stagger (W204)"
  },
  {
    "yearStart": 2010,
    "yearEnd": 2026,
    "brand": "Mercedes-AMG",
    "model": "E63",
    "generation": "W212 / W213",
    "submodel": "Base / S",
    "front": "20x10 ET35",
    "rear": "20x11 ET38",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/e63-fitment",
    "setup": "20\" Aggressive Stagger"
  },
  {
    "yearStart": 2010,
    "yearEnd": 2026,
    "brand": "Mercedes-AMG",
    "model": "E63",
    "generation": "W212 / W213",
    "submodel": "Base / S",
    "front": "19x9.5 ET30",
    "rear": "19x10.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/e63-fitment",
    "setup": "19\" Performance Stagger (W212)"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2024,
    "brand": "Mercedes-AMG",
    "model": "GT",
    "generation": "C190",
    "submodel": "GTS / GTC / GTR",
    "front": "10x19 ET50",
    "rear": "12x20 ET45",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/amggt-fitment",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2015,
    "brand": "Mitsubishi",
    "model": "Lancer Evolution",
    "generation": "Evo X",
    "submodel": "GSR / MR",
    "front": "18x9.5 ET22",
    "rear": "18x9.5 ET22",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/evo-fitment",
    "setup": "18\" Aggressive Square"
  },
  {
    "yearStart": 2008,
    "yearEnd": 2015,
    "brand": "Mitsubishi",
    "model": "Lancer Evolution",
    "generation": "Evo X",
    "submodel": "GSR / MR",
    "front": "17x9 ET25",
    "rear": "17x9 ET25",
    "boltPattern": "5x114.3",
    "centerBore": "67.1",
    "guideUrl": "/pages/evo-fitment",
    "setup": "17\" Lightweight Track Square"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2026,
    "brand": "Nissan",
    "model": "GT-R",
    "generation": "R35",
    "submodel": "Premium / Nismo",
    "front": "20x10 ET25",
    "rear": "20x11 ET25",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/gtr-fitment",
    "setup": "20\" OEM+ Stagger"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2026,
    "brand": "Nissan",
    "model": "GT-R",
    "generation": "R35",
    "submodel": "Premium / Nismo",
    "front": "20x10.5 ET15",
    "rear": "20x12 ET15",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/gtr-fitment",
    "setup": "20\" Wide-Body Stagger"
  },
  {
    "yearStart": 1989,
    "yearEnd": 2002,
    "brand": "Nissan",
    "model": "Silvia / 240SX",
    "generation": "S13 / S14 / S15",
    "submodel": "Base / Spec R",
    "front": "18x9.5 ET15",
    "rear": "18x9.5 ET15",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/silvia-fitment",
    "setup": "18\" Aggressive Square"
  },
  {
    "yearStart": 1989,
    "yearEnd": 2002,
    "brand": "Nissan",
    "model": "Silvia / 240SX",
    "generation": "S13 / S14 / S15",
    "submodel": "Base / Spec R",
    "front": "17x9 ET22",
    "rear": "17x9 ET22",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/silvia-fitment",
    "setup": "17\" Grip Square"
  },
  {
    "yearStart": 1989,
    "yearEnd": 2002,
    "brand": "Nissan",
    "model": "Skyline GT-R",
    "generation": "R32 / R33 / R34",
    "submodel": "GT-R",
    "front": "18x9.5 ET22",
    "rear": "18x10.5 ET22",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/skyline-gtr-fitment",
    "setup": "18\" Aggressive Stagger"
  },
  {
    "yearStart": 1989,
    "yearEnd": 2002,
    "brand": "Nissan",
    "model": "Skyline GT-R",
    "generation": "R32 / R33 / R34",
    "submodel": "GT-R",
    "front": "18x9.5 ET22",
    "rear": "18x9.5 ET22",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/skyline-gtr-fitment",
    "setup": "18\" Square Track"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Nissan",
    "model": "Z",
    "generation": "RZ34",
    "submodel": "Track (18\")",
    "front": "19x9.5 ET22",
    "rear": "19x10.5 ET15",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/nissan-z-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Nissan",
    "model": "Z",
    "generation": "RZ34",
    "submodel": "Track (18\")",
    "front": "18x9.5 ET22",
    "rear": "18x10.5 ET15",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/nissan-z-fitment",
    "setup": "18\" Track Stagger"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2026,
    "brand": "Nissan",
    "model": "Z / 370Z",
    "generation": "RZ34 / Z34",
    "submodel": "Performance / Nismo / Base",
    "front": "19x9.5 ET22",
    "rear": "19x10.5 ET15",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/nissan-z-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2009,
    "yearEnd": 2026,
    "brand": "Nissan",
    "model": "Z / 370Z",
    "generation": "RZ34 / Z34",
    "submodel": "Performance / Nismo / Base",
    "front": "18x9.5 ET22",
    "rear": "18x10.5 ET15",
    "boltPattern": "5x114.3",
    "centerBore": "66.1",
    "guideUrl": "/pages/nissan-z-fitment",
    "setup": "18\" Track Stagger"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "911",
    "generation": "991 / 992",
    "submodel": "Widebody / Turbo S / C4S",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "5x130 / Centerlock",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "911",
    "generation": "991 / 992",
    "submodel": "Widebody / Turbo S / C4S",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "5x130 / Centerlock",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1",
    "submodel": "Carrera / S",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2012,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1",
    "submodel": "Carrera / S",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2013,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "Carrera / GTS 5-Lug",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2013,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "Carrera / GTS 5-Lug",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "GT3",
    "front": "20x9",
    "rear": "20x12",
    "boltPattern": "5x130 / Center Lock",
    "centerBore": "71.6 / 101",
    "guideUrl": "/pages/991-gt3-fitment",
    "setup": "Factory Standard: 20\" Square"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "GT3",
    "front": "19x9 or 19x9.5",
    "rear": "19x12",
    "boltPattern": "5x130 / Center Lock",
    "centerBore": "71.6 / 101",
    "guideUrl": "/pages/991-gt3-fitment",
    "setup": "19\" Track Setup"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2020,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "GT3 RS / GT2 RS",
    "front": "20x9",
    "rear": "20x12",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/991-gt3-fitment",
    "setup": "Factory Standard: 20\" Square"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2020,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "GT3 RS / GT2 RS",
    "front": "19x9 or 19x9.5",
    "rear": "19x12",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/991-gt3-fitment",
    "setup": "19\" Track Setup"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "GTS Center Lock",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "GTS Center Lock",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "Turbo 5 Lug",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "Turbo 5 Lug",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "Turbo Center Lock",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.1 / 991.2",
    "submodel": "Turbo Center Lock",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.2",
    "submodel": "Carrera / S / T / 4 / 4S / Targa",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2019,
    "brand": "Porsche",
    "model": "911",
    "generation": "991.2",
    "submodel": "Carrera / S / T / 4 / 4S / Targa",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "3.7 Turbo S Center Lock",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "3.7 Turbo S Center Lock",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "4.0 GT3",
    "front": "20x9.5",
    "rear": "21x12",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/992-gt3-fitment",
    "setup": "20/21\" Street & Canyon"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "4.0 GT3",
    "front": "20x9.5",
    "rear": "20x12",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/992-gt3-fitment",
    "setup": "20\" Square Track Focus"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "4.0 GT3 RS",
    "front": "10Jx20 ET45",
    "rear": "13Jx21 ET31",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/992-gt3-rs-fitment",
    "setup": "20\" / 21\" Factory Stagger"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "4.0 GT3 RS",
    "front": "10Jx20 ET45",
    "rear": "13Jx20 ET31",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/992-gt3-rs-fitment",
    "setup": "20\" Track Setup"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "4.0 GT3 RS",
    "front": "10Jx19 ET45",
    "rear": "13Jx19 ET31",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/992-gt3-rs-fitment",
    "setup": "19\" Slick Setup"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "Carrera / S / T / GTS / Targa / Dakar",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "Carrera / S / T / GTS / Targa / Dakar",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "GTS CL / S/T",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2019,
    "yearEnd": 2025,
    "brand": "Porsche",
    "model": "911",
    "generation": "992.1",
    "submodel": "GTS CL / S/T",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 1995,
    "yearEnd": 1998,
    "brand": "Porsche",
    "model": "911",
    "generation": "993",
    "submodel": "Carrera / 4 / 4S",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 1995,
    "yearEnd": 1998,
    "brand": "Porsche",
    "model": "911",
    "generation": "993",
    "submodel": "Carrera / 4 / 4S",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 1996,
    "yearEnd": 1998,
    "brand": "Porsche",
    "model": "911",
    "generation": "993",
    "submodel": "Turbo / Turbo S",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 1996,
    "yearEnd": 1998,
    "brand": "Porsche",
    "model": "911",
    "generation": "993",
    "submodel": "Turbo / Turbo S",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 1999,
    "yearEnd": 2004,
    "brand": "Porsche",
    "model": "911",
    "generation": "996",
    "submodel": "Carrera / GT2 / GT3",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 1999,
    "yearEnd": 2004,
    "brand": "Porsche",
    "model": "911",
    "generation": "996",
    "submodel": "Carrera / GT2 / GT3",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2002,
    "yearEnd": 2005,
    "brand": "Porsche",
    "model": "911",
    "generation": "996",
    "submodel": "Turbo / Turbo S",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2002,
    "yearEnd": 2005,
    "brand": "Porsche",
    "model": "911",
    "generation": "996",
    "submodel": "Turbo / Turbo S",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2005,
    "yearEnd": 2012,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "Carrera / GT3 / GTS / Targa (5-Lug)",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2005,
    "yearEnd": 2012,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "Carrera / GT3 / GTS / Targa (5-Lug)",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2007,
    "yearEnd": 2011,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "GT3 / GTS Center Lock",
    "front": "20x8.5 or 20x9",
    "rear": "20x11 or 20x11.5 (High Offset)",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "991 Generation (2012-2019)"
  },
  {
    "yearStart": 2007,
    "yearEnd": 2011,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "GT3 / GTS Center Lock",
    "front": "20x8.5",
    "rear": "21x11.5",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-nb-fitment",
    "setup": "992 Carrera & Carrera S"
  },
  {
    "yearStart": 2007,
    "yearEnd": 2013,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "Turbo / Turbo S 5 Lug",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2007,
    "yearEnd": 2013,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "Turbo / Turbo S 5 Lug",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2007,
    "yearEnd": 2013,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "Turbo / Turbo S Center Lock",
    "front": "20x9 ET45",
    "rear": "21x12 ET45",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20/21\" Flush Stagger"
  },
  {
    "yearStart": 2007,
    "yearEnd": 2013,
    "brand": "Porsche",
    "model": "911",
    "generation": "997",
    "submodel": "Turbo / Turbo S Center Lock",
    "front": "20x9.5 ET45",
    "rear": "20x12.5 ET40",
    "boltPattern": "Center Lock",
    "centerBore": "101",
    "guideUrl": "/pages/porsche-wb-fitment",
    "setup": "20\" Track Stagger"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "981",
    "submodel": "Boxster / S / GTS",
    "front": "9x19 ET50",
    "rear": "10.5x19 ET44",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "981",
    "submodel": "Spyder",
    "front": "9x20 ET50",
    "rear": "11x20 ET50",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2012,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "987",
    "submodel": "Boxster / S",
    "front": "9x18 ET46",
    "rear": "10x18 ET36",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2014,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "981",
    "submodel": "Cayman / S / GTS",
    "front": "9x19 ET50",
    "rear": "10.5x19 ET44",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2016,
    "yearEnd": 2016,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "981",
    "submodel": "GT4",
    "front": "9x20 ET50",
    "rear": "11x20 ET50",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2006,
    "yearEnd": 2012,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "987",
    "submodel": "Cayman / S / R",
    "front": "9x18 ET46",
    "rear": "10x18 ET36",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/fitment-guides",
    "setup": "Recommended Fitment"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2026,
    "brand": "Subaru",
    "model": "WRX / STI",
    "generation": "VA / VB",
    "submodel": "Base / Limited",
    "front": "18x9.5 ET38",
    "rear": "18x9.5 ET38",
    "boltPattern": "5x114.3",
    "centerBore": "56.1",
    "guideUrl": "/pages/wrx-fitment",
    "setup": "18\" Flush Square"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2026,
    "brand": "Subaru",
    "model": "WRX / STI",
    "generation": "VA / VB",
    "submodel": "Base / Limited",
    "front": "17x9 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "56.1",
    "guideUrl": "/pages/wrx-fitment",
    "setup": "17\" Lightweight Track Square"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Tesla",
    "model": "Model 3 / Model Y",
    "generation": "Various",
    "submodel": "Long Range / Performance",
    "front": "19x9.5 ET35",
    "rear": "19x9.5 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "64.1",
    "guideUrl": "/pages/tesla-model3-fitment",
    "setup": "19\" Efficiency Square"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Tesla",
    "model": "Model 3 / Model Y",
    "generation": "Various",
    "submodel": "Long Range / Performance",
    "front": "18x8.5 ET40",
    "rear": "18x8.5 ET40",
    "boltPattern": "5x114.3",
    "centerBore": "64.1",
    "guideUrl": "/pages/tesla-model3-fitment",
    "setup": "18\" Range-Optimized Square"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Toyota",
    "model": "GR Corolla",
    "generation": "GZEA14H",
    "submodel": "Core / Circuit / Morizo",
    "front": "18x9 ET45",
    "rear": "18x9 ET45",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/gr-corolla-fitment",
    "setup": "18\" Flush Square"
  },
  {
    "yearStart": 2023,
    "yearEnd": 2026,
    "brand": "Toyota",
    "model": "GR Corolla",
    "generation": "GZEA14H",
    "submodel": "Core / Circuit / Morizo",
    "front": "17x9 ET42",
    "rear": "17x9 ET42",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/gr-corolla-fitment",
    "setup": "17\" Lightweight Track Square"
  },
  {
    "yearStart": 2020,
    "yearEnd": 2026,
    "brand": "Toyota",
    "model": "GR Supra",
    "generation": "A90 / A91",
    "submodel": "3.0 / 2.0",
    "front": "19x9.5 ET25",
    "rear": "19x10.5 ET35",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/supra-fitment",
    "setup": "19\" Aggressive Stagger"
  },
  {
    "yearStart": 2020,
    "yearEnd": 2026,
    "brand": "Toyota",
    "model": "GR Supra",
    "generation": "A90 / A91",
    "submodel": "3.0 / 2.0",
    "front": "18x9.5 ET35",
    "rear": "18x10.5 ET25",
    "boltPattern": "5x112",
    "centerBore": "66.6",
    "guideUrl": "/pages/supra-fitment",
    "setup": "18\" Track Stagger"
  },
  {
    "yearStart": 1991,
    "yearEnd": 1999,
    "brand": "Toyota",
    "model": "MR2",
    "generation": "SW20",
    "submodel": "Turbo / NA",
    "front": "17x8 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/mr2-fitment",
    "setup": "17\" Flush Stagger (SW20)"
  },
  {
    "yearStart": 1991,
    "yearEnd": 1999,
    "brand": "Toyota",
    "model": "MR2",
    "generation": "SW20",
    "submodel": "Turbo / NA",
    "front": "16x8 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/mr2-fitment",
    "setup": "16/17\" Track Stagger (SW20)"
  },
  {
    "yearStart": 2000,
    "yearEnd": 2007,
    "brand": "Toyota",
    "model": "MR2",
    "generation": "ZZW30",
    "submodel": "Spyder",
    "front": "17x8 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "4x100",
    "centerBore": "54.1",
    "guideUrl": "/pages/mr2-fitment",
    "setup": "17\" Flush Stagger (SW20)"
  },
  {
    "yearStart": 2000,
    "yearEnd": 2007,
    "brand": "Toyota",
    "model": "MR2",
    "generation": "ZZW30",
    "submodel": "Spyder",
    "front": "16x8 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "4x100",
    "centerBore": "54.1",
    "guideUrl": "/pages/mr2-fitment",
    "setup": "16/17\" Track Stagger (SW20)"
  },
  {
    "yearStart": 1993,
    "yearEnd": 2002,
    "brand": "Toyota",
    "model": "Supra",
    "generation": "A80 / JZA80",
    "submodel": "Twin Turbo / NA",
    "front": "18x9 ET25",
    "rear": "18x10 ET25",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/mk4-supra-fitment",
    "setup": "18\" Flush Stagger"
  },
  {
    "yearStart": 1993,
    "yearEnd": 2002,
    "brand": "Toyota",
    "model": "Supra",
    "generation": "A80 / JZA80",
    "submodel": "Twin Turbo / NA",
    "front": "17x9 ET25",
    "rear": "17x10 ET25",
    "boltPattern": "5x114.3",
    "centerBore": "60.1",
    "guideUrl": "/pages/mk4-supra-fitment",
    "setup": "17\" Lightweight Stagger"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Toyota / Subaru",
    "model": "GR86 / BRZ",
    "generation": "ZN8 / ZD8",
    "submodel": "Base / Premium",
    "front": "18x9.5 ET38",
    "rear": "18x9.5 ET38",
    "boltPattern": "5x100",
    "centerBore": "56.1",
    "guideUrl": "/pages/gr86-fitment",
    "setup": "18\" Flush Square"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Toyota / Subaru",
    "model": "GR86 / BRZ",
    "generation": "ZN8 / ZD8",
    "submodel": "Base / Premium",
    "front": "17x9 ET35",
    "rear": "17x9 ET35",
    "boltPattern": "5x100",
    "centerBore": "56.1",
    "guideUrl": "/pages/gr86-fitment",
    "setup": "17\" Lightweight Track Square"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2026,
    "brand": "Volkswagen",
    "model": "Golf",
    "generation": "Mk7 / Mk8",
    "submodel": "GTI / Golf R",
    "front": "19x8.5 ET45",
    "rear": "19x8.5 ET45",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/golf-fitment",
    "setup": "19\" Flush Square"
  },
  {
    "yearStart": 2015,
    "yearEnd": 2026,
    "brand": "Volkswagen",
    "model": "Golf",
    "generation": "Mk7 / Mk8",
    "submodel": "GTI / Golf R",
    "front": "18x8.5 ET45",
    "rear": "18x8.5 ET45",
    "boltPattern": "5x112",
    "centerBore": "57.1",
    "guideUrl": "/pages/golf-fitment",
    "setup": "18\" Lightweight Track Square"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "718",
    "submodel": "Boxster / S / T / GTS",
    "front": "20x8.5 ET42 or 20x9 ET42",
    "rear": "20x10.5 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "20\" Street & Aesthetic Setup"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "718",
    "submodel": "Boxster / S / T / GTS",
    "front": "19x9 ET42",
    "rear": "19x10.5 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "19\" Performance Focus"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "718",
    "submodel": "Spyder",
    "front": "20x9 ET45",
    "rear": "20x11 ET49",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "20\" Street & Aesthetic Setup"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "718",
    "submodel": "Spyder",
    "front": "19x9 ET45",
    "rear": "19x11 ET49",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "19\" Performance Focus"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Boxster",
    "generation": "718",
    "submodel": "Spyder RS",
    "front": "20x8.5 ET47",
    "rear": "20x11 ET50",
    "boltPattern": "Center Lock",
    "centerBore": "84",
    "guideUrl": "/pages/718-fitment",
    "setup": "20\" OEM+ RS Fitment"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "718",
    "submodel": "Cayman / S / T / GTS",
    "front": "20x8.5 ET42 or 20x9 ET42",
    "rear": "20x10.5 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "20\" Street & Aesthetic Setup"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "718",
    "submodel": "Cayman / S / T / GTS",
    "front": "19x9 ET42",
    "rear": "19x10.5 ET45",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "19\" Performance Focus"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "718",
    "submodel": "GT4",
    "front": "20x9 ET45",
    "rear": "20x11 ET49",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "20\" Street & Aesthetic Setup"
  },
  {
    "yearStart": 2017,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "718",
    "submodel": "GT4",
    "front": "19x9 ET45",
    "rear": "19x11 ET49",
    "boltPattern": "5x130",
    "centerBore": "71.6",
    "guideUrl": "/pages/718-fitment",
    "setup": "19\" Performance Focus"
  },
  {
    "yearStart": 2022,
    "yearEnd": 2026,
    "brand": "Porsche",
    "model": "Cayman",
    "generation": "718",
    "submodel": "GT4 RS",
    "front": "20x8.5 ET47",
    "rear": "20x11 ET50",
    "boltPattern": "Center Lock",
    "centerBore": "84",
    "guideUrl": "/pages/718-fitment",
    "setup": "20\" OEM+ RS Fitment"
  }
];

try {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = window.GT_FITMENTS;
  }
} catch(e){}
